const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const pageContainer = path.resolve('src/containers/Homepage/index.js')

  return createPage({
    path: router(route.path, {}),
    component: pageContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
